/* Ash and Grit – card + product page enhancements (Oct 2026)
   1. Fit tag above the title on product pages
   2. Fit label on theme product cards that don't have one (e.g. "You might also like")
   3. Colour swatches + quick add on home page cards for products with a Colour option
   Remove the render 'ag-enhance' line in snippets/stylesheets.liquid to undo. */
(function () {
  var FIT = window.AG_FIT || {};
  var SWATCH = {
    'black': '#111111', 'sand': '#c9b48f', 'slate green': '#4a5d55',
    'scarlet red': '#b0242c', 'sandstone tan': '#d6b48a', 'white': '#f2f2f2', 'grey': '#777777', 'gray': '#777777'
  };

  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function pdpTag() {
    var f = window.AG_PDP_FIT;
    if (!f || document.querySelector('.ag-pdp-fit')) return;
    var h1 = document.querySelector('main h1');
    if (!h1) return;
    h1.parentNode.insertBefore(el('p', 'ag-pdp-fit', f), h1);
  }

  function cardFits(root) {
    (root || document).querySelectorAll('product-card').forEach(function (c) {
      if (c.querySelector('.ag-fit-auto, p[style*="color:#555"], .ag-card-fit')) return;
      var a = c.querySelector('a.product-card__link');
      var f = FIT[handleFrom(a && a.getAttribute('href'))];
      if (!f) return;
      var price = c.querySelector('product-price, .price, [class*="price"]');
      var label = el('p', 'ag-fit-auto', f);
      if (price && price.parentNode) price.parentNode.insertBefore(label, price);
      else (c.querySelector('.product-card__content') || c).appendChild(label);
    });
  }

  function optIndex(p, re) {
    for (var i = 0; i < p.options.length; i++) {
      var n = typeof p.options[i] === 'string' ? p.options[i] : p.options[i].name;
      if (re.test(n)) return i;
    }
    return -1;
  }
  function imgUrl(v, p) {
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    if (!src) return null;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
  }
  function refreshCart(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'ag-quick-add', data: { source: 'ag-quick-add', itemCount: cart.item_count } }
      }));
    } catch (e) {}
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count], .cart-count-bubble span').forEach(function (n) {
      n.textContent = cart.item_count;
    });
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.remove('visually-hidden'); });
  }

  function build(card, p, ci, si) {
    if (card.dataset.agEnhanced) return;
    card.dataset.agEnhanced = '1';
    var info = card.querySelector('.ag-card-info') || card;
    var main = card.querySelector('.ag-card-img-main');
    var key = 'option' + (ci + 1);
    var sizeKey = si > -1 ? 'option' + (si + 1) : null;
    // Only show colours that have at least one size for sale (hides held or sold-out colours, e.g. a launch on hold)
    var allColours = (p.options[ci].values || []).slice();
    var colours = allColours.filter(function (c) { return p.variants.some(function (v) { return v[key] === c && v.available; }); });
    if (!colours.length) colours = allColours;
    var vm = (card.getAttribute('href') || '').match(/variant=(\d+)/);
    var startV = vm && p.variants.filter(function (v) { return String(v.id) === vm[1]; })[0];
    var current = startV && colours.indexOf(startV[key]) > -1 ? startV[key] : colours[0];

    var row = el('div', 'ag-sw-row');
    var qa = el('button', 'ag-qa', '+ Quick add');
    qa.type = 'button';
    var sizes = el('div', 'ag-sizes');
    var msg = el('p', 'ag-added');
    msg.hidden = true;

    function stop(e) { e.preventDefault(); e.stopPropagation(); }

    function renderSizes() {
      sizes.textContent = '';
      p.variants.filter(function (v) { return v[key] === current; }).forEach(function (v) {
        var b = el('button', 'ag-size', sizeKey ? v[sizeKey] : v.title);
        b.type = 'button';
        b.disabled = !v.available;
        b.setAttribute('aria-label', 'Add ' + p.title + ' ' + current + ' ' + (sizeKey ? v[sizeKey] : '') + ' to cart');
        b.addEventListener('click', function (e) {
          stop(e);
          b.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
          }).then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              refreshCart(cart);
              msg.textContent = 'Added ' + (sizeKey ? v[sizeKey] + ' ' : '') + 'to cart ✓';
              msg.hidden = false;
              sizes.classList.remove('open');
              setTimeout(function () { msg.hidden = true; }, 3500);
            })
            .catch(function () { msg.textContent = 'Couldn’t add. Try again.'; msg.hidden = false; })
            .then(function () { b.disabled = !v.available; });
        });
        sizes.appendChild(b);
      });
    }

    function select(c, swapImage) {
      current = c;
      row.querySelectorAll('.ag-sw').forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.colour === c);
        s.setAttribute('aria-pressed', s.dataset.colour === c ? 'true' : 'false');
      });
      var v = p.variants.filter(function (x) { return x[key] === c && x.available; })[0] ||
              p.variants.filter(function (x) { return x[key] === c; })[0];
      if (v) {
        card.setAttribute('href', '/products/' + p.handle + '?variant=' + v.id);
        var u = imgUrl(v, p);
        if (swapImage && main && u) { main.src = u; card.classList.add('ag-swapped'); }
      }
      renderSizes();
    }

    colours.forEach(function (c) {
      var s = el('button', 'ag-sw');
      s.type = 'button';
      s.dataset.colour = c;
      s.title = c;
      s.setAttribute('aria-label', c);
      s.style.background = SWATCH[String(c).toLowerCase()] || '#888';
      s.addEventListener('click', function (e) { stop(e); select(c, true); });
      row.appendChild(s);
    });
    row.appendChild(el('span', 'ag-sw-name', colours.length + ' colours'));

    qa.addEventListener('click', function (e) { stop(e); sizes.classList.toggle('open'); });
    sizes.addEventListener('click', stop);

    var after = info.querySelector('.ag-card-price') || info.lastElementChild;
    info.insertBefore(row, after ? after.nextSibling : null);
    info.appendChild(qa);
    info.appendChild(sizes);
    info.appendChild(msg);
    select(current, false);
  }

  function enhanceHomeCards() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('a.ag-card:not([data-ag-enhanced])'));
    var seen = {};
    cards.forEach(function (c) {
      var h = handleFrom(c.getAttribute('href'));
      if (!h || seen[h]) return;
      seen[h] = true;
      fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var ci = optIndex(p, /colou?r/i);
        if (ci < 0) return;
        var si = optIndex(p, /size/i);
        cards.forEach(function (c2) { if (handleFrom(c2.getAttribute('href')) === h) build(c2, p, ci, si); });
      }).catch(function () {});
    });
  }

  function run() {
    pdpTag();
    cardFits(document);
    enhanceHomeCards();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () { cardFits(document); }, 300);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
